'use client';
import { faro, getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

export default function FrontendObservability() {
  if (typeof window !== 'undefined' && window.location.host.includes('localhost')) return;
  if (faro.api) {
    return null;
  }

  try {
    const _faro = initializeFaro({
      url: process.env.NEXT_PUBLIC_COLLECTOR_URL,
      apiKey: process.env.NEXT_PUBLIC_FARO_KEY,
      app: {
        name: 'intercontinental-web',
        namespace: 'intercontinental',
        version: process.env.APP_VERSION,
        release: process.env.APP_VERSION,
        environment: process.env.APP_ENV,
      },

      instrumentations: [...getWebInstrumentations(), new TracingInstrumentation()],
    });
  } catch (e) {
    return null;
  }
  return null;
}
